import { cn } from '@rematter/ui-web';

type VarianceIndicatorProps = {
  variancePercentage: number | null;
  withinTolerance: boolean | null;
};

const formatPercentage = (value: number): string => {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
};

export const VarianceIndicator = ({
  variancePercentage,
  withinTolerance,
}: VarianceIndicatorProps) => {
  if (variancePercentage == null || withinTolerance == null) {
    return <span className="text-neutral/40">&mdash;</span>;
  }

  return (
    <span
      className={cn(
        '@VarianceIndicator',
        cn(
          'inline-flex items-center gap-1 text-sm font-medium tabular-nums',
          withinTolerance && 'text-success',
          !withinTolerance && 'text-failure',
        ),
      )}
    >
      <span
        className={cn(
          'size-2 rounded-full',
          withinTolerance && 'bg-success',
          !withinTolerance && 'bg-failure',
        )}
      />
      {formatPercentage(variancePercentage)}
    </span>
  );
};
